import React from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";

import { getTip, getType } from "@utils/offer";

import { EventType } from "@gp/models";
import { BetSlipEvent } from "@api-types/agency/bet-slip/BetSlipEvent";
import { format } from "@utils/format";

export default observer(function MultiOffersComponent(props: {
	multiOffers: BetOffer[] | BetSlipEvent[];
}) {
	return (
		<div className="widget--bets__multi">
			{props.multiOffers.map((m, index) => (
				<div
					key={index}
					className="widget--bets__pick widget--bets__bb"
				>
					{m.sportData.eventType == EventType.NORMAL && (
						<div
							className={`widget--bets__type u-color--offer--${format.formatBettingOfferStatus(
								m.bettingOfferStatus
							)}`}
						>
							{getType(m)}:
							<span
								className={`widget--bets__tip u-color--offer--${format.formatBettingOfferStatus(
									m.bettingOfferStatus
								)}`}
							>
								{getTip(m)}
							</span>
						</div>
					)}
				</div>
			))}
		</div>
	);
});
